import { ComponentHeader } from '../shared/ComponentHeader'
import { ComponentTitle } from '../shared/ComponentTitle'
import clsx from 'clsx'
import { ResponsiveContainer } from 'recharts'
import { ChartHeatmapDataSchema, ChartHeatmapUISchema } from './types-v3'
import type { ChartConfig } from './types-v3'
import { ChartBody } from './ChartBody'
import { ComponentActionsContainer } from '../shared/ComponentActionsContainer'
import { getComponentHeights } from '../utils'

function HeatmapScrollWrapper({
  width = 0,
  height = 0,
  data,
  chartConfig,
  contentHeight,
  hasHeader,
}: {
  width?: number
  height?: number
  data: ChartHeatmapDataSchema
  chartConfig: ChartConfig
  contentHeight: string
  hasHeader: boolean
}) {
  return (
    <div className={clsx('flex h-full min-h-0 flex-col', { 'pt-5': hasHeader })} style={{ height: contentHeight }}>
      <ChartBody width={width} height={height} topInset={hasHeader ? 20 : 0} data={data} chartConfig={chartConfig} />
    </div>
  )
}

export function ChartHeatmapContent({
  uiSchema,
  dataSchema,
  tileFilters,
}: {
  uiSchema: ChartHeatmapUISchema
  dataSchema: ChartHeatmapDataSchema
  tileFilters?: React.ReactNode
}) {
  const { title = undefined, description = undefined, chartConfig, emphasizeHeader } = uiSchema
  const hasHeader = !!title && !!tileFilters
  const { contentHeight } = getComponentHeights(emphasizeHeader, hasHeader)

  return (
    <div className="flex h-full flex-col">
      {hasHeader && (
        <ComponentHeader emphasize={emphasizeHeader}>
          <ComponentTitle title={title} description={description} />
          <ComponentActionsContainer>{tileFilters}</ComponentActionsContainer>
        </ComponentHeader>
      )}
      <ResponsiveContainer width="100%" height={contentHeight}>
        <HeatmapScrollWrapper
          data={dataSchema}
          chartConfig={chartConfig}
          contentHeight={contentHeight}
          hasHeader={hasHeader}
        />
      </ResponsiveContainer>
    </div>
  )
}
